var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickerMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 2.64844V7.98177L9.83333 5.98177L11.8333 7.98177V2.64844M3.83333 2.64844H13.1667C13.903 2.64844 14.5 3.24539 14.5 3.98177V13.3151C14.5 14.0515 13.903 14.6484 13.1667 14.6484H3.83333C3.09695 14.6484 2.5 14.0515 2.5 13.3151V3.98177C2.5 3.24539 3.09695 2.64844 3.83333 2.64844Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerMobile);
export default __webpack_public_path__ + "static/media/date-picker-mobile.f9589ba5d993749c7235b0ecba39dd87.svg";
export { ForwardRef as ReactComponent };